module.exports = __webpack_public_path__ + "static/media/Datagrity.64b6eaa8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Datagrity.svg
// module id = 26
// module chunks = 0